module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Aidan Carr was born and brought up on the Fylde coast in Lancashire, where he was educated by Jesuit nuns and the Irish Christian Brothers before reading law at Manchester University.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("After qualifying as a solicitor, he provided representation in the Shipman Inquiry and more recently was retained by British Cycling to represent their lead physiotherapist in both the UKAD and House of Commons Select Committee investigations into alleged wrongdoing in cycling and the subsequent General Medical Councils prosecution of the Team Sky doctor.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("He is an ardent sports fan and Vice-President of Broughton Park RUFC, where he coached youth rugby. He is a lifelong supporter of Manchester United and was previously the Honorary Solicitor to the Association of Former Manchester United Players.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Aidan lives in England and Italy, where he continues to coach youth rugby at Viareggio RFC.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-256644c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0